import React from "react";

export default function Loader({ label = "Loading..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 gap-3">
      <div className="w-12 h-12 border-4 border-gold-200 border-t-saffron-500 rounded-full animate-spin" />
      <p className="text-saffron-700 text-sm font-medium">{label}</p>
    </div>
  );
}
